// src/components/Notification.js
import React from 'react';
import { useNotification } from '../context/NotificationContext';
import './Notification.css';

const Notification = () => {
    const { notification } = useNotification();

    if (!notification.isVisible) {
        return null;
    }

    // Determina la clase CSS según el tipo de notificación
    const notificationClass = `notification-bar ${notification.type}`;

    return (
        <div className={notificationClass}>
            {notification.message}
        </div>
    );
};

export default Notification;